import { flex } from "@styled-system/patterns";

export const buttonWrapperClass = flex({
	gap: "8",
	justify: "end",
	marginBottom: "8",
});
